module.exports = __webpack_public_path__ + "d7a0587676c1c74d3c8c79017ec004c7.svg";